import {LitElement, html, css} from 'lit';
import {navigator} from 'lit-element-router';
import {classMap} from 'lit/directives/class-map.js';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';

import {routeUrl} from '../util/routeUrl';

@customElement('router-link')
export class Link extends navigator(LitElement) {

	@property({type: Object})
	params = {};

	@property({type: Boolean})
	active = false;

	static styles = [
		css`
		  :host {

		  }

		  a {
			font-family: var(--font-family-light);
			font-size: var(--font-size-widget);
			height: var(--height-widget);
			text-transform: uppercase;
			letter-spacing: 1px;
			background-color: transparent;
			border: none;
			cursor: pointer;
			line-height: 0;
			transition: max-width ease-in-out 0.4s, padding ease-in-out 0.4s, color 0.4s;
			color: var(--color-grey4);
			padding-left: 0;
			padding-right: var(--very-small-padding);
			text-decoration: none;
		  }
		  .active {
			color: var(--color-grey2);
		  }
		`
	];

	constructor() {
		super();
		this.href = '';
		this.active = false;
	}

	render() {
		return html`
			<a @click="${this.linkClick}" class=${classMap({active: this.active})} href="${routeUrl(this.params)}">
				<slot></slot>
			</a>
		`;
	}

	linkClick(event) {
		event.preventDefault();
		this.navigate(routeUrl(this.params));
	}
}
